import { getMainApi } from "@Shared/utils/ajax";
export const getSearchResults = (searchString, ajaxOptions = {}) => {
  return getMainApi({
    searchString
  }, "/search", ajaxOptions);
};